<!--  -->
<template>
    <div class="business-content-main cussettle-content">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div>
            <div class="search-ctn" style="min-height: 0">
                <div class="search-ctn-left">
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询（F2）</el-button>
                    <el-button size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()" v-if="permission.printSettlement">{{
                        permission.printSettlement
                    }}</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="exportForm()" v-if="permission.exportSettlement">
                        <i class="fa fa-file-excel-o"></i>
                        {{ permission.exportSettlement }}
                    </el-button>
                    <el-button v-if="permission.print && !isDefaultSet" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="prints()">{{
                        permission.print
                    }}</el-button>
                    <el-button v-if="permission.printPreview && !isDefaultSet" size="small" icon="el-icon-view" class="search-btn btn-primary" @click="printPreview()">{{
                        permission.printPreview
                    }}</el-button>
                    <el-button
                        v-if="(permission.printPreview || permission.print) && isDefaultSet"
                        size="small"
                        icon="el-icon-printer"
                        class="search-btn btn-primary"
                        @click="printPreview()"
                        >打印</el-button
                    >
                </div>
                <div class="search-ctn-right" v-if="summaryStr">
                    <div class="section-summary">
                        <div>
                            <span>{{ summaryStr }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    highlight-current-row
                    style="width: 100%"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border=""
                    :data="tableData"
                    height="420"
                    ref="multipleTable"
                    :row-class-name="tableRowClassName"
                    @row-click="rowClick"
                    :row-key="getRowKeys"
                    @sort-change="sortChange"
                    v-el-table-infinite-scroll="tableLoad"
                    empty-text="暂无结算数据"
                >
                    <el-table-column show-overflow-tooltip width="180" prop="OrderCode" label="结算单号"></el-table-column>
                    <el-table-column show-overflow-tooltip width="120" prop="PayTime" label="结算日期"></el-table-column>
                    <el-table-column show-overflow-tooltip width="160" prop="EntpCusName" label="物流公司"></el-table-column>
                    <el-table-column show-overflow-tooltip width="120" prop="PayTypeName" label="支付方式"></el-table-column>
                    <el-table-column show-overflow-tooltip width="120" prop="ClosingBalance" label="本次收取金额">
                        <template slot-scope="scope">
                            {{ (scope.row.ClosingBalance - scope.row.UnPaid).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="UnPaid" label="减收"> </el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100" prop="Remark" label="备注"></el-table-column>
                    <el-table-column show-overflow-tooltip width="70px" prop="Operator" label="操作人"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable width="160px" prop="CreateTime" label="操作时间"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="110px">
                        <template slot-scope="scope">
                            <span v-if="scope.row.IsLock" style="color: rgb(199, 199, 199)">已锁帐</span>
                            <el-button
                                v-if="permission.stateBack && !scope.row.IsLock"
                                :title="permission.stateBack"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="backState(scope.row.SettleId)"
                                >{{ permission.stateBack }}</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="section-title">
                <div>
                    <span>{{ !orderCode ? '' : '【' + orderCode + '】' }}结算明细</span>
                </div>
            </div>
            <div>
                <el-table
                    v-loading="detailLoading"
                    class="detail-table"
                    :data="orderDetailData"
                    style="width: 100%"
                    height="280px"
                    border=""
                    :row-key="getDetailRowKeys"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    empty-text="点击结算列表即可查看申请明细"
                    :summary-method="getSummaries"
                    show-summary
                    ref="detailTable"
                >
                    <el-table-column show-overflow-tooltip width="120px" prop="OrgName" label="部门"></el-table-column>
                    <el-table-column prop="Date" label="单据日期" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="OrderCode" label="单号" width="210" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div style="display: flex; flex-direction: row">
                                <i v-if="scope.row.OrderId && scope.row.OrderType != 2"
                                    ><el-link
                                        :underline="false"
                                        :href="
                                            scope.row.OrderType == 0
                                                ? '/#/salesManage/salesOrder/check?id=' + scope.row.OrderId
                                                : '/#/salesManage/salesReturns/edit_v2?type=1&SReturnId=' + scope.row.OrderId
                                        "
                                        target="_blank"
                                        >{{ scope.row.OrderCode }}</el-link
                                    ></i
                                >
                                <i v-else>{{ scope.row.OrderCode }}</i>
                                <img
                                    v-show="scope.row.OrderId && scope.row.OrderType != 2"
                                    src="@/assets/images/preview.png"
                                    title="打印预览"
                                    style="margin-left: 10px; width: 24px; height: 24px"
                                    @click.stop="viewOrderDetail(scope.row.OrderType, scope.row.OrderId)"
                                />
                                <img v-show="scope.row.PRType == '合并账'" src="@/assets/images/view.png" title="查看合并明细"
                                    style="margin-left: 5px; margin-top: 5px; width: 24px; height: 13px" @click.stop="viewCombineDetail(scope.row)" />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="CName" label="客户名称" width="160" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="PRType" label="单据类型" width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="TotalAmount" label="应收总额" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType != 1 ? scope.row.TotalAmount : -scope.row.TotalAmount }}</template>
                    </el-table-column>
                    <el-table-column prop="AgentAmount" label="代收总额" width="120" show-overflow-tooltip> </el-table-column>
                    <el-table-column label="已收总额" prop="ActuralAmount" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType != 1 ? scope.row.ActuralAmount : -scope.row.ActuralAmount }}</template>
                    </el-table-column>
                    <el-table-column prop="NowPay" label="本次收取" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType != 1 ? scope.row.NowPay : -scope.row.NowPay }}</template>
                    </el-table-column>
                    <el-table-column prop="Remark" label="备注" min-width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="SName" label="开单员" width="80" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                title="结算单据搜索"
                :visible.sync="dialogVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="search-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="物流公司">
                            <el-select
                                ref="search_0"
                                class="search-item"
                                size="small"
                                style="width: 100%"
                                v-model="searchData.CName"
                                remote
                                filterable
                                allow-create
                                placeholder="请输入物流公司名称"
                                :remote-method="searchCustom"
                                v-select-scroll-more="searchCustomLoad"
                                popper-class="my-select"
                            >
                                <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单号">
                            <el-input
                                class="search-item"
                                style="width: 100%"
                                size="small"
                                v-model.trim="searchData.OrderCode"
                                v-filter-special-char="searchData.OrderCode"
                                placeholder="请输入结算单号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="支付方式">
                            <el-select ref="search_2" class="search-item" style="width: 100%" size="small" v-model="searchData.PayType" multiple collapse-tags clearable>
                                <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="操作人">
                            <el-select v-model="searchData.ApplyId" style="width: 100%" class="search-item" size="small" filterable clearable placeholder="请选择">
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="操作日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime1"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate1TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="结算日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime2"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate2TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printVisible" width="870px">
                <div class="dialog-content" v-if="printVisible">
                    <PrintSettleContent
                        @closeDialog="
                            () => {
                                printVisible = false;
                            }
                        "
                        :SettleId="currentRow.SettleId"
                    ></PrintSettleContent>
                </div>
            </el-dialog>
            <!--  打印  -->
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printDialogVisible" width="870px">
                <div class="dialog-content" v-if="printDialogVisible">
                    <printLogisticsSettlement
                        @closeDialog="closePrintDialog"
                        :sParams="searchParams"
                        :isDefaultSet="isDefaultSet"
                        :isPreview="isPreview"
                        :isInit="true"
                    ></printLogisticsSettlement>
                </div>
            </el-dialog>
            <!-- 打印隐藏内容，用于直接打印 -->
            <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important">
                <printLogisticsSettlement
                    ref="printDom"
                    @closeDialog="closePrintDialog"
                    :sParams="searchParams"
                    :isDefaultSet="isDefaultSet"
                    :isPreview="isPreview"
                    :isInit="false"
                ></printLogisticsSettlement>
            </div>
            <el-dialog :close-on-click-modal="false" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printOrderPreview" width="870px">
                <div class="dialog-content" v-if="printOrderPreview">
                    <printContent @closeDialog="closeOrderPrintDialog" :printIds="idList" :showDisc="showDisc" :isInit="true"></printContent>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printReturnPreview" width="870px">
                <div class="dialog-content" v-if="printReturnPreview">
                    <printReturnContent @closeDialog="closeOrderPrintDialog" :printIds="idList" :isInit="true"></printReturnContent>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" append-to-body :title="'【' + EntpCusName + '】' + comCode + ' 合并明细'" :visible.sync="isShowDetailDlg" width="900px">
                <div class="dialog-content" v-if="isShowDetailDlg">
                    <CombineDetails @closeDetails="closeDetailDialog" :RecordId="recordId"></CombineDetails>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import PrintSettleContent from '@/components/business/revenue/printSettlement';
import breadcrumb from '@/components/common/breadcrumb';
import printLogisticsSettlement from '@/components/printModels/printLogisticsSettlement';
import CombineDetails from '@/components/logistics/combineDetails';
import Vue from 'vue';
export default {
    mixins: [],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        PrintSettleContent,
        printLogisticsSettlement,
        CombineDetails
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_0.focus();
                });
            }
        }
    },
    data() {
        return {
            isShowDetailDlg: false,
            comCode: '',
            recordId: '',
            EntpCusName:'',
            isStartSearch: false,
            summaryStr: '',
            orderCode: '',
            datetime1: [],
            datetime2: [],
            loading: '',
            detailLoading: '',
            cusName: '',
            multipleSelection: null,
            dialogVisible: false,
            printVisible: false,
            isShowConfirmDialog: false,
            dialogSettleUpVisible: false,
            scanData: '',
            dataindex: 0,
            stopFresh: false,
            isStopReq: false,
            isShowSummary: false,
            settleId: '',
            unPaid: 0,
            sumPayable: 0,
            payWayList: [],
            searchData: {
                State: '',
                CName: '',
                OrderCode: '',
                ApplyId: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                SortProp: '',
                SortType: '',
                PayType: [],
                page: 1,
                limit: 15
            },
            searchParams: {},
            currentRow: {},
            tableData: [],
            orderDetailData: [],
            tableDataLength: 0,
            permission: {},
            SIdList: [],
            cusId: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            printDialogVisible: false,
            isDefaultSet: true, //是否使用浏览器的打印功能
            isPreview: false, //是否出现预览界面
            askShowDisc: false,
            showDisc: false,
            printOrderPreview: false,
            printReturnPreview: false,
            idList: []
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        // if (this.tableCode) this.getSetsData();
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);

        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date2 = new Date(year2, month2, day2, 0);
        this.datetime2.push(date1);
        this.datetime2.unshift(date2);

        this.searchData.UStartDate = date2;
        this.searchData.UEndDate = date1;             
    },
    mounted() {
        if (this.$route.query.code) this.searchData.OrderCode = this.$route.query.code;

        this.permission = this.$util.getPermission('LogisticsSettlement');
        this.getConfigByCodes().then(() => {
            this.getTableData();
            this.getPay();
            this.initSearchSelectData();
        });

        this.getPrintComponents();
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['syllqdysz', 'dyyl', 'xwdyxxdxxyh'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                                case 'dyyl': //是否出现预览界面
                                    this.isPreview = result;
                                    break;
                                case 'xwdyxxdxxyh': //询问是否打印订单优惠价格
                                    this.askShowDisc = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        handleKeyEvent(e) {
            if (this.printDialogVisible) return;
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                that.dialogVisible = true;
                that.isStartSearch = true;
            }
            if (key === 13) {
                if (that.dialogVisible) {
                    that.handleSearch();
                    that.isStartSearch = false;
                } else if (that.isShowConfirmDialog) {
                    if (that.$refs.confirmReceipt) {
                        that.$refs.confirmReceipt.submitForm();
                    }
                }
            }
            if (key === 27) {
                if (that.dialogVisible) {
                    that.dialogVisible = false;
                    that.isStartSearch = false;
                } else if (that.isShowConfirmDialog) that.isShowConfirmDialog = false;
            }
            //下键
            if (key == 40) {
                if (that.dataindex != that.tableDataLength - 1) {
                    if (that.currentRow && that.currentRow.SettleId) {
                        that.dataindex++;
                    } else that.dataindex = 0;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                            that.getOrderDetail();
                        }
                    });
                }
            }
            //上键
            if (key == 38) {
                if (that.dataindex != 0) {
                    that.dataindex--;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                            that.getOrderDetail();
                        }
                    });
                }
            }
        },
        tableLoad() {
            if (!this.stopFresh) {
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },
        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
            this.currentRow = row;
            this.multipleSelection = [];
            this.$refs.detailTable.clearSelection();
            this.getOrderDetail();
        },
        getOrderDetail() {
            let item = this.currentRow;
            if (item) {
                this.orderCode = item.OrderCode;
                this.detailLoading = true;
                let url = '/api/RevenueManagement_H/GetSettlementsDetails';
                this.$util
                    .axiosGet({
                        url: url,
                        data: {
                            SId: item.SettleId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            this.orderDetailData = res.data;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.detailLoading = false;
                    });
            }
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchLogistic(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        initSearchSelectData() {
            //可以把这些常用的数据放到缓存里面
            this.getSIdList();
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        resetSearch() {
            this.searchData = {
                State: '',
                CName: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                ApplyId: '',
                SortProp: '',
                SortType: '',
                PayType: [],
                page: 1,
                limit: 15
            };
            this.datetime1 = [];
            this.datetime2 = [];
            this.searchCustom('');
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            let that = this;
            if (!that.isStopReq) {
                if (that.searchData.page == 1) {
                    that.searchParams = { ...that.searchData };
                } else {
                    that.searchParams.page = that.searchData.page;
                }
                that.stopFresh = true;
                that.isStopReq = true;
                that.$util
                    .axiosPost({
                        url: '/api/RevenueManagement_H/GetLogisticsSettlementsList',
                        data: that.searchParams
                    })
                    .then(res => {
                        let data = res.data;
                        if (res.errcode != 201) {
                            if (!data) {
                                if (that.searchData.page == 1) {
                                    that.tableData = [];
                                    that.tableDataLength = 0;
                                    that.summaryStr = '';
                                }
                                return;
                            } else {
                                if (that.searchData.page == 1) {
                                    that.tableData = [];
                                    that.tableDataLength = res.count;
                                    that.summaryStr = data.SummaryStr;
                                }
                            }
                            let list = [...that.tableData, ...data.DataList];
                            that.tableData = list;
                            that.stopFresh = data.DataList.length < that.searchData.limit;
                        } else {
                            that.stopFresh = that.tableData.length >= that.tableDataLength;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        that.isStopReq = false;
                    });
            }
        },
        handleSearch() {
            if (this.$refs.multipleTable) this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.tableData = [];
            this.getTableData();
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.SettleId;
        },
        getDetailRowKeys(row) {
            return row.RecordId;
        },
        getSummaries(param) {
            const { data } = param;
            let amount1 = 0;
            let amount2 = 0;
            let amount3 = 0;
            let amount4 = 0;
            data.forEach(ele => {
                if (ele.OrderType != 1) {
                    amount1 = (Number(amount1) + Number(ele.TotalAmount)).toFixed(2);
                    amount2 = (Number(amount2) + Number(ele.AgentAmount)).toFixed(2);
                    amount3 = (Number(amount3) + Number(ele.ActuralAmount)).toFixed(2);
                    amount4 = (Number(amount4) + Number(ele.NowPay)).toFixed(2);
                } else {
                    amount1 = (Number(amount1) - Number(ele.TotalAmount)).toFixed(2);
                    amount3 = (Number(amount3) - Number(ele.ActuralAmount)).toFixed(2);
                    amount4 = (Number(amount4) - Number(ele.NowPay)).toFixed(2);
                }
            });
            return ['', '合计：' + this.orderDetailData.length, '', '', amount1 + ' 元', amount2 + ' 元', amount3 + ' 元', amount4 + ' 元', '', ''];
        },
        print() {
            if (!this.currentRow) {
                this.$util.warningMsg('请选择一张结算单进行打印');
                return;
            }
            this.printVisible = true;
        },
        exportForm() {
            if (!this.currentRow) {
                this.$util.warningMsg('请选择导出一张结算单');
                return;
            }
            this.$util.exportFile({
                url: '/api/RevenueManagement/ExportSettlements',
                data: {
                    SettleId: this.currentRow.SettleId
                }
            });
        },
        backState(id) {
            let that = this;
            if (id) {
                that.$confirm('是否回退结算单的状态吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: `/api/RevenueManagement_H/BackSettleStates?SettleId=${id}`
                            })
                            .then(res => {
                                if (res.errcode == 0) {
                                    that.$util.successMsg('回退状态成功');

                                    for (let i = 0; i < that.tableData.length; i++) {
                                        if (that.tableData[i].SettleId == id) {
                                            that.tableData.splice(i, 1);
                                            that.currentRow = {};
                                            that.orderDetailData = [];
                                            return;
                                        }
                                    }
                                }
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效申请款项');
            }
        },
        // 打印预览
        printPreview() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }
            if (this.tableData.length == 0) {
                this.$util.warningMsg('没有可打印的数据');
                return;
            }
            this.printDialogVisible = true;
        },
        prints() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }
            if (this.tableData.length == 0) {
                this.$util.warningMsg('没有可打印的数据');
                return;
            }
            this.$refs.printDom.init(true);
        },
        closePrintDialog() {
            this.printDialogVisible = false;
        },
        viewOrderDetail(orderType, orderId) {
            if (orderId) {
                this.idList.push(orderId);
                if (orderType == 0) {
                    if (!this.askShowDisc) this.printOrderPreview = true;
                    else {
                        this.showDisc = true;
                        this.$confirm('是否打印显示优惠价？', '提示', {
                            confirmButtonText: '是',
                            cancelButtonText: '否',
                            type: 'warning'
                        })
                            .then(() => {
                                this.showDisc = true;
                                this.printOrderPreview = true;
                            })
                            .catch(() => {
                                this.showDisc = false;
                                this.printOrderPreview = true;
                            });
                    }
                } else if (orderType == 1) {
                    this.printReturnPreview = true;
                }
            } else {
                this.$util.warningMsg('要打印的订单异常，请刷新后重新操作');
            }
        },
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents().then(data => {
                if (data) {
                    Vue.component('printContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printContent', () => import('@/components/printModels/printSales'));
                }
            });

            that.$util.getPrintComponents(4).then(data => {
                if (data) {
                    Vue.component('printReturnContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printReturnContent', () => import('@/components/printModels/printSaleReturn'));
                }
            });
        },
        closeOrderPrintDialog() {
            this.printOrderPreview = false;
            this.printReturnPreview = false;
            this.idList = [];
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        viewCombineDetail(item) {
            if (this.currentRow) {
                this.EntpCusName = this.currentRow.EntpCusName;
            } else {
                this.EntpCusName = '';
            }
            this.recordId = item.OrderId;
            this.comCode = item.OrderCode;
            this.isShowDetailDlg = true;
        },
        closeDetailDialog() {
            this.isShowDetailDlg = false;
        },
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 12.5%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
#search-dc-dialog,
#confirm-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
#confirm-dialog::-webkit-scrollbar {
    display: none;
}
.v-content {
    width: 100%;
    height: calc(100vh);
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.table-ctn {
    display: flex;
    width: 100%;
    margin-bottom: 10px;
}
</style>
<style lang="less">
.cussettle-content {
    .el-link {
        justify-content: flex-start;
    }
    .el-table {
        margin-bottom: 0px;

        th {
            padding: 4px 0;
        }
    }
    .detail-table {
        .el-table__body {
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }

                td {
                    padding: 2px 0;
                }
            }
        }
        .el-table__footer {
            td {
                padding: 4px 0;
            }
        }
    }
}
.el-table__row {
    td:not(is-hidden):last-child {
        border-left: 1px solid #ebeef5;
    }
}
.el-table__header {
    th:not(is-hidden):last-child {
        border-left: 1px solid #ebeef5;
    }
}
.el-table {
    overflow: visible !important;
}
</style>
